var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-container',[_c('v-card-text',[_c('h1',{attrs:{"data-cy":"lostPasswordChanged"}},[_vm._v(_vm._s(_vm.$t('passwordLost.changed.title')))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }